import { createActions } from 'redux-actions';

const { setContractField, resetDefaultValues } = createActions(
  'SET_CONTRACT_FIELD',
  'RESET_DEFAULT_VALUES'
);

export { setContractField, resetDefaultValues };
